function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Row, Container, Col, Table } from 'react-bootstrap';
import { Skeleton, message, Button, DatePicker, Form, Input, Descriptions, Typography, Tag, Select, Statistic, notification, Space, Popover } from 'antd';
import moment from "moment";
import Common from "../components/includes/Common";
import Moment from "react-moment";
var Text = Typography.Text,
  Link = Typography.Link;
var Search = Input.Search;
var RangePicker = DatePicker.RangePicker;
import { ThreeDots, XLg } from "react-bootstrap-icons";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var History = function History() {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([{
      value: 0,
      label: "TOUTES"
    }]),
    _useState4 = _slicedToArray(_useState3, 2),
    compOptions = _useState4[0],
    setCompOptions = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    customers = _useState6[0],
    setCustomers = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    currentCustomer = _useState8[0],
    setCurrentCustomer = _useState8[1];
  var _useState9 = useState(0),
    _useState0 = _slicedToArray(_useState9, 2),
    totalVisite = _useState0[0],
    setTotalVisite = _useState0[1];
  var _useState1 = useState(0),
    _useState10 = _slicedToArray(_useState1, 2),
    totalPe = _useState10[0],
    setTotalPe = _useState10[1];
  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    totalVa = _useState12[0],
    setTotalVa = _useState12[1];
  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    totalFit = _useState14[0],
    setTotalFit = _useState14[1];
  var _useState15 = useState(0),
    _useState16 = _slicedToArray(_useState15, 2),
    totalFitRes = _useState16[0],
    setTotalFitRes = _useState16[1];
  var _useState17 = useState(0),
    _useState18 = _slicedToArray(_useState17, 2),
    totalUnfit = _useState18[0],
    setTotalUnfit = _useState18[1];
  var _useState19 = useState(moment().subtract(2, 'weeks').day(6).startOf('day').format()),
    _useState20 = _slicedToArray(_useState19, 2),
    from = _useState20[0],
    setFrom = _useState20[1];
  var _useState21 = useState(moment().subtract(1, 'weeks').day(5).endOf('day').format()),
    _useState22 = _slicedToArray(_useState21, 2),
    to = _useState22[0],
    setTo = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    isSummaryLoading = _useState24[0],
    setIsSummaryLoading = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    open = _useState26[0],
    setOpen = _useState26[1];
  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    summaryOpen = _useState28[0],
    setsummaryOpen = _useState28[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var onSearchFinish = function onSearchFinish(values) {
    setIsDataLoading(true);
    axios.post("".concat(Common.baseApiUrl, "getperiodiccompanycostumers"), {
      company_id: values.company_id,
      user_id: Common.currentUser.id,
      protocole: values.protocole,
      from: moment(values.period[0].$d).format(),
      to: moment(values.period[1].$d).format(),
      candidate_code: values.candidate_code
    }).then(function (response) {
      setCustomers(response.data.customers);
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };
  var handleOpenChange = function handleOpenChange(newOpen) {
    setOpen(newOpen);
  };
  var handlesummaryOpenChange = function handlesummaryOpenChange(newOpen) {
    setsummaryOpen(newOpen);
  };
  var loadSummary = function loadSummary(dfrom, dto) {
    setIsSummaryLoading(true);
    axios.post(Common.baseApiUrl + "getcustomersummary", {
      user_id: Common.currentUser.id,
      from: dfrom,
      to: dto
    }).then(function (response) {
      setTotalVisite(response.data.totalVisite);
      setTotalPe(response.data.totalPe);
      setTotalVa(response.data.totalVa);
      setTotalFit(response.data.totalFit);
      setTotalFitRes(response.data.totalFitRes);
      setTotalUnfit(response.data.totalUnfit);
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue " + error.toString(),
        delay: 4
      });
    })["finally"](function () {
      setIsSummaryLoading(false);
    });
  };
  useEffect(function () {
    loadSummary(from, to);
    setIsDataLoading(true);
    form.setFieldsValue({
      company_id: 0,
      candidate_code: ""
    });
    axios.get(Common.baseApiUrl + 'getcompanylist').then(function (response) {
      if (response.data.status == 200) {
        setCompOptions([{
          value: 0,
          label: "TOUTES"
        }]);
        response.data.companyList.forEach(function (c) {
          setCompOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: c.id,
              label: c.label
            }]);
          });
        });
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [from, to]);
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsxs(Col, {
        children: [/*#__PURE__*/_jsx(Text, {
          mark: true,
          children: /*#__PURE__*/_jsx("b", {
            children: "#HISTORIQUES CANDIDATS"
          })
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
      })
    }), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsxs(Col, {
        children: [/*#__PURE__*/_jsxs(Space, {
          direction: "horizontal",
          children: [/*#__PURE__*/_jsxs(Tag, {
            color: "#f50",
            children: ["R\xE9sum\xE9 du ", /*#__PURE__*/_jsx(Moment, {
              date: from,
              format: "DD/MM/YYYY HH:mm"
            }), " au ", /*#__PURE__*/_jsx(Moment, {
              date: to,
              format: "DD/MM/YYYY HH:mm"
            })]
          }), /*#__PURE__*/_jsx(Popover, {
            placement: "topLeft",
            open: summaryOpen,
            trigger: "click",
            onOpenChange: handlesummaryOpenChange,
            title: "RECHERCHE",
            content: /*#__PURE__*/_jsxs(Form, {
              onFinish: function onFinish(values) {
                setFrom(moment(values.period[0].$d).format());
                setTo(moment(values.period[1].$d).format());
              },
              layout: "vertical",
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "period",
                label: "P\xE9riode",
                rules: [{
                  required: true,
                  message: "Choisir une date de depart"
                }],
                children: /*#__PURE__*/_jsx(RangePicker, {
                  needConfirm: false,
                  format: "DD/MM/YYYY"
                })
              }), /*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx(Form.Item, {
                  children: /*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    htmlType: "submit",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "ENVOYER"
                    })
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  children: /*#__PURE__*/_jsx(Button, {
                    loading: isSummaryLoading,
                    type: "link",
                    onClick: function onClick() {
                      setsummaryOpen(false);
                    },
                    icon: /*#__PURE__*/_jsx(XLg, {
                      size: 24
                    }),
                    children: " Fermer"
                  })
                })]
              })]
            }),
            children: /*#__PURE__*/_jsx(Button, {
              size: "small",
              children: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(ThreeDots, {
                  size: 20
                })
              })
            })
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
      })
    }), /*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        lg: 2,
        md: 2,
        sm: 6,
        children: /*#__PURE__*/_jsx("div", {
          className: "infoBox",
          style: {
            background: "#E8E9DF"
          },
          children: /*#__PURE__*/_jsx(Statistic, {
            title: /*#__PURE__*/_jsx("b", {
              children: "TOTAL RECU"
            }),
            value: totalVisite
          })
        })
      }), /*#__PURE__*/_jsx(Col, {
        lg: 2,
        md: 2,
        sm: 6,
        children: /*#__PURE__*/_jsx("div", {
          className: "infoBox",
          style: {
            background: "#E1E1CD"
          },
          children: /*#__PURE__*/_jsx(Statistic, {
            title: /*#__PURE__*/_jsx("b", {
              children: "TOTAL PRE-E."
            }),
            value: totalPe
          })
        })
      }), /*#__PURE__*/_jsx(Col, {
        lg: 2,
        md: 2,
        sm: 6,
        children: /*#__PURE__*/_jsx("div", {
          className: "infoBox",
          style: {
            background: "#E1CECC"
          },
          children: /*#__PURE__*/_jsx(Statistic, {
            title: /*#__PURE__*/_jsx("b", {
              children: "TOTAL VA"
            }),
            value: totalVa
          })
        })
      }), /*#__PURE__*/_jsx(Col, {
        lg: 2,
        md: 2,
        sm: 6,
        children: /*#__PURE__*/_jsx("div", {
          className: "infoBox",
          style: {
            background: "#D9CDE0"
          },
          children: /*#__PURE__*/_jsx(Statistic, {
            title: /*#__PURE__*/_jsx("b", {
              children: "TOTAL APTES"
            }),
            value: totalFit
          })
        })
      }), /*#__PURE__*/_jsx(Col, {
        lg: 2,
        md: 2,
        sm: 6,
        children: /*#__PURE__*/_jsx("div", {
          className: "infoBox",
          style: {
            background: "#DAF6FD"
          },
          children: /*#__PURE__*/_jsx(Statistic, {
            title: /*#__PURE__*/_jsx("b", {
              children: "TOTAL APTE RES."
            }),
            value: totalFitRes
          })
        })
      }), /*#__PURE__*/_jsx(Col, {
        lg: 2,
        md: 2,
        sm: 6,
        children: /*#__PURE__*/_jsx("div", {
          className: "infoBox",
          style: {
            background: "#FDF2DA"
          },
          children: /*#__PURE__*/_jsx(Statistic, {
            title: /*#__PURE__*/_jsx("b", {
              children: "TOTAL INAPTES"
            }),
            value: totalUnfit
          })
        })
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        lg: 12,
        md: 12,
        children: /*#__PURE__*/_jsx(Popover, {
          placement: "topLeft",
          open: open,
          trigger: "click",
          onOpenChange: handleOpenChange,
          title: "RECHERCHE",
          content: /*#__PURE__*/_jsx(Form, {
            form: form,
            onFinish: onSearchFinish,
            children: /*#__PURE__*/_jsxs(Space, {
              direction: "vertical",
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "company_id",
                children: /*#__PURE__*/_jsx(Select, {
                  options: compOptions,
                  style: {
                    width: "200px"
                  }
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "period",
                rules: [{
                  required: true,
                  message: "Veuillez choisir une période"
                }],
                children: /*#__PURE__*/_jsx(RangePicker, {})
              }), /*#__PURE__*/_jsx(Form.Item, {
                label: "Protocole",
                name: "protocole",
                children: /*#__PURE__*/_jsx(Select, {
                  options: [{
                    value: "0",
                    label: "Tout"
                  }, {
                    value: "rio",
                    label: "RIO"
                  }, {
                    value: "emg",
                    label: "EMG"
                  }],
                  style: {
                    width: "100%"
                  }
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "candidate_code",
                children: /*#__PURE__*/_jsx(Input, {
                  placeholder: "Code dossier"
                })
              }), /*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx(Form.Item, {
                  children: /*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    htmlType: "submit",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "CHERCHER"
                    })
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  children: /*#__PURE__*/_jsx(Button, {
                    loading: isDataLoading,
                    type: "link",
                    onClick: function onClick() {
                      setOpen(false);
                    },
                    icon: /*#__PURE__*/_jsx(XLg, {
                      size: 24
                    }),
                    children: " Fermer"
                  })
                })]
              })]
            })
          }),
          children: /*#__PURE__*/_jsx(Button, {
            size: "small",
            children: /*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(ThreeDots, {
                size: 20
              })
            })
          })
        })
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        lg: 12,
        md: 12,
        children: /*#__PURE__*/_jsxs(Table, {
          size: "small",
          striped: true,
          responsive: true,
          bordered: true,
          children: [/*#__PURE__*/_jsx("thead", {
            children: /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Date"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Ref"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Nom"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Date Nais."
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Type"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Poste"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Nat."
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Cat\xE9gorie"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Telephone"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Societe"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Aptitude"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Conclusion"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Recommendation"
                })
              })]
            })
          }), /*#__PURE__*/_jsx("tbody", {
            children: customers.map(function (c) {
              return /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: /*#__PURE__*/_jsx(Moment, {
                    date: c.created_at,
                    format: "DD/MM/YYYY"
                  })
                }), /*#__PURE__*/_jsx("td", {
                  children: c.candidate_code
                }), /*#__PURE__*/_jsx("td", {
                  children: c.name
                }), /*#__PURE__*/_jsx("td", {
                  children: /*#__PURE__*/_jsx(Moment, {
                    date: c.birthdate,
                    format: "DD/MM/YYYY"
                  })
                }), /*#__PURE__*/_jsx("td", {
                  children: c.type = "0" ? /*#__PURE__*/_jsxs(_Fragment, {
                    children: [c.reason == "0" && "VISITE ANNUELLE", c.reason == "1" && "VISITE PRE-AMBAUCHE", c.reason == "2" && "V. JOURNALIERS", c.reason == "3" && "PERMIS DE TRAVAIL"]
                  }) : /*#__PURE__*/_jsx(_Fragment, {
                    children: c.type
                  })
                }), /*#__PURE__*/_jsx("td", {
                  children: c.job
                }), /*#__PURE__*/_jsx("td", {
                  children: c.nationality
                }), /*#__PURE__*/_jsx("td", {
                  children: c.category != "0" && /*#__PURE__*/_jsx("b", {
                    children: c.category
                  })
                }), /*#__PURE__*/_jsx("td", {
                  children: c.mobile_first
                }), /*#__PURE__*/_jsx("td", {
                  children: c.company.label
                }), /*#__PURE__*/_jsx("td", {
                  children: c.conclusion && (c.conclusion.conclusion == 1 || c.conclusion.conclusion == 2 || c.conclusion.conclusion == 3 || c.conclusion.conclusion == 7 || c.conclusion.conclusion == 8 || c.conclusion.conclusion == 9 || c.conclusion.conclusion == 10 || c.conclusion.conclusion == 11) ? /*#__PURE__*/_jsx("div", {
                    children: "A"
                  }) : /*#__PURE__*/_jsx("div", {
                    children: "I"
                  })
                }), /*#__PURE__*/_jsx("td", {
                  children: c.conclusion && c.conclusion.mr_conclusion
                }), /*#__PURE__*/_jsx("td", {
                  children: c.conclusion && c.conclusion.mr_recommandation
                })]
              }, c.id);
            })
          })]
        })
      })
    })]
  });
};
export default History;